import { gql } from "@apollo/client";

export const DO_EMPTY_FEED = gql`
  mutation DoEmptyFeed($domain: String!, $terminalid: Int!, $triggerAmount: Int!, $pauseTime: Int!, $amount: Int!) {
    doEmptyFeed(domain: $domain, terminalid: $terminalid, triggerAmount: $triggerAmount, pauseTime: $pauseTime, amount: $amount) {
      code
      success
      message
    }
  }
`

export interface DoEmptyFeed {
  domain: string
  terminalid: number
  triggerAmount: number
  pauseTime: number
  amount: number
}

interface DoEmptyFeedAction {
  code: String
  success: Boolean
  message: string
}

export interface DoEmptyFeedResponse {
  doEmptyFeed: DoEmptyFeedAction
}